<med-popover-trigger menu-id="userMenu">
    <med-button size="small" color="primary" button-type="flat">
        <span class="button-label">{{userName}}</span>
        <span class="nav-icon"></span>
    </med-button>
</med-popover-trigger>
<med-menu id="userMenu">
  <med-menu-item id="changePassword" (click)="onChangePassword()" *ngIf="!isSSOUser">{{'changePassword' | translate}}</med-menu-item>
  <med-menu-item id="updateProfile" (click)="onUpdateProfile()">{{'updateProfile' | translate}}</med-menu-item>
</med-menu>
